'use strict';

import { IFloorPlanDto_Props } from './FloorPlanDto.if';
import IFloorPlanTranslationDto from './FloorPlanTranslationDto.if';
import FloorPlanTranslationDto from './FloorPlanTranslationDto';
import { IModelSource } from '../interface/db';
import DBUtil from '../private/db.util';

function _translations(
    this: Partial<IFloorPlanDto_Props>,
    db: IModelSource,
): Promise<Array<IFloorPlanTranslationDto>> {
    if (!this.id) {
        return Promise.reject('Missing field floorplan.id');
    }

    const _that = this;
    return new Promise(function (resolve, reject) {
        DBUtil.allFloorplanTranslations<IFloorPlanTranslationDto>(db, FloorPlanTranslationDto)
            .then(result => result.filter(translation => translation.floorPlanId === _that.id))
            .then(translations => resolve(translations))
            .catch(error => reject(error));
    });
}

export interface IFloorPlanDto_Linkables {
    translations: (db: IModelSource) => Promise<IFloorPlanTranslationDto[]>;
}

/** 
 * @description all custom properties for
   FloorPlanDto & methods to link against other entities
*/
function linkables(model: Partial<IFloorPlanDto_Props>): IFloorPlanDto_Linkables {
    return {
        translations: _translations.bind(model),
    };
}

export default linkables;
